import React from "react";

function BioData(props) {

  
  
  
     if(!props.bio_data || props.bio_data.length === 0){
        return (
            <div className='text-center mt-10 font-mono'>
                <h2 className='text-2xl font-bold'>No Bio Data Available</h2>
            </div>
        )
    }
    
  

  return (
    <div className="bioData-con font-mono">

      <div className="bg-slate-50 p-4 applcnt-pro-bioData-inner-con border-solid border-black border-[1px] rounded-lg mt-5 shadow-2xl">
      <h3 className="bg-blue-950 text-white mb-3 mt-2 text-center text-3xl">
        <b> Bio Data </b>
      </h3>
        <ul>
          <li><b>Firstname:</b> <span>{props.bio_data.fname}</span></li> 
          <li><b>Surname:</b> <span>{props.bio_data.lname}</span></li>
          <li><b>Email:</b> <span>{props.sign_up.email}</span></li>
          <li><b>Phone Number:</b> <span>{props.bio_data.mobileNumber}</span></li>
          <li><b>Marital Status:</b> <span>{props.bio_data.marital_status}</span></li>
        </ul>
      </div>


      <div className="bg-slate-50 p-4 applcnt-pro-bioData-inner-con rounded-lg border-solid border-black border-2 mt-5 shadow-2xl">
      <h3 className="bg-blue-950 text-white mb-3 mt-3 text-center text-3xl ">
        <b> Demography </b>
      </h3>
        <ul>
          <li><b>Resdential Type:</b> <span>{props.bio_data.resdential_type}</span></li>
          <li><b>State of origin:</b> <span>{props.demography_data.state_of_origin}</span></li>
          <li><b>Local govt:</b> <span>{props.demography_data.local_gov}</span></li>
          <li><b>Home address:</b> <span>{props.demography_data.home_address}</span></li>
        </ul>
      </div>


      <div className="bg-slate-50 p-4 applcnt-pro-bioData-inner-con rounded-lg border-solid border-black border-2 mt-5 shadow-2xl">
      <h3 className="bg-blue-950  text-white mb-3 mt-3 text-center text-3xl">
        <b> Parents Info </b>
      </h3>
        <ul>
          <li><b>Father's Fullname:</b> <span>{props.parent_data.father_full_name}</span></li>
          <li><b>Mother's Fullname:</b> <span>{props.parent_data.mother_full_name}</span></li>
          <li><b>Guardian's Phone No:</b> <span>{props.parent_data.guardian_valid_mobile}</span></li>
        </ul>
      </div>


      
    </div>
  );
}

export default BioData;
